export default {
  badge: 'Значок',
  open: 'Відкрити',
  close: 'Закрити',
  dismiss: 'Відхилити',
  confirmEdit: {
    ok: 'ОК',
    cancel: 'Скасувати',
  },
  dataIterator: {
    noResultsText: 'В результаті пошуку нічого не знайдено',
    loadingText: 'Завантаження...',
  },
  dataTable: {
    itemsPerPageText: 'Рядків на сторінці:',
    ariaLabel: {
      sortDescending: 'Відсортовано за спаданням.',
      sortAscending: 'Відсортовано за зростанням.',
      sortNone: 'Не відсортовано.',
      activateNone: 'Активувати, щоб видалити сортування.',
      activateDescending: 'Активувати, щоб відсортувати за спаданням.',
      activateAscending: 'Активувати, щоб відсортувати за зростанням.',
    },
    sortBy: 'Відсортувати за',
  },
  dataFooter: {
    itemsPerPageText: 'Елементів на сторінці:',
    itemsPerPageAll: 'Всі',
    nextPage: 'Наступна сторінка',
    prevPage: 'Попередня сторінка',
    firstPage: 'Перша сторінка',
    lastPage: 'Остання сторінка',
    pageText: '{0}-{1} з {2}',
  },
  dateRangeInput: {
    divider: 'до',
  },
  datePicker: {
    itemsSelected: 'Вибрано {0}',
    range: {
      title: 'Оберіть дати',
      header: 'Введіть дати',
    },
    title: 'Оберіть дату',
    header: 'Введіть дату',
    input: {
      placeholder: 'Введіть дату',
    },
  },
  noDataText: 'Немає даних для відображення',
  carousel: {
    prev: 'Попередній слайд',
    next: 'Наступий слайд',
    ariaLabel: {
      delimiter: 'Слайд {0} з {1}',
    },
  },
  calendar: {
    moreEvents: 'Ще {0}',
    today: 'Сьогодні',
  },
  input: {
    clear: 'Очистити {0}',
    prependAction: '{0} попередня дія',
    appendAction: '{0} наступна дія',
    otp: 'Будь ласка, введіть символ OTP {0}',
  },
  fileInput: {
    counter: '{0} файлів',
    counterSize: '{0} файлів ({1} загалом)',
  },
  fileUpload: {
    title: 'Перетягніть файли сюди',
    divider: 'або',
    browse: 'Переглянути файли',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Оберіть час',
  },
  pagination: {
    ariaLabel: {
      root: 'Навігація по сторінках',
      next: 'Наступна сторінка',
      previous: 'Попередня сторінка',
      page: 'Перейти на сторінку {0}',
      currentPage: 'Поточна сторінка, Сторінка {0}',
      first: 'Перша сторінка',
      last: 'Остання сторінка',
    },
  },
  stepper: {
    next: 'Далі',
    prev: 'Назад',
  },
  rating: {
    ariaLabel: {
      item: 'Оцінка {0} з {1}',
    },
  },
  loading: 'Завантаження...',
  infiniteScroll: {
    loadMore: 'Завантажити більше',
    empty: 'Немає більше даних',
  },
  rules: {
    required: 'Це поле є обов’язковим',
    email: 'Будь ласка, введіть дійсну електронну адресу',
    number: 'Це поле може містити лише цифри',
    integer: 'Це поле може містити лише цілі числа',
    capital: 'Це поле може містити лише великі літери',
    maxLength: 'Ви повинні ввести максимум {0} символів',
    minLength: 'Ви повинні ввести мінімум {0} символів',
    strictLength: 'Довжина введеного поля є недійсною',
    exclude: 'Символ {0} не дозволений',
    notEmpty: 'Будь ласка, виберіть принаймні одне значення',
    pattern: 'Недійсний формат',
  },
}
